<template>
	<div class="control-center">
		<NavMenu v-if="state_key.render" class="nav-menu" />
		<div class="container">
			<template v-if="state_key.render">
				<CashbookControl
					:root="root"
					:state="state_key"
					:preselected-manager="root.cashbook && root.cashbook.manager_name"
					:cashbook="root.cashbook"
					:cashbook-shift="root.cashbook_shift"
					:opened-cashdesks="root.opened_cashdesks"
					:loading-actions="props.loadingActions"
					:validation-errors="props.validation_errors"
					:toggle-cashbook-closal-modal="toggleCashbookClosalModal"
					:toggle-inventory-act-modal="toggleInventoryActModal"
					:open-cashbook-open-modal="openCashbookOpenModal"
					:toggle-workplace-select-modal="toggleWorkplaceSelectModal"
					:open-cashbook-with-shift="openCashbookWithShift"
					:open-cashbook="openCashbook"
					:init-cashbook-shift-transfer="initCashbookShiftTransfer"
					:cancel-cashbook-shift-transfer="cancelCashbookShiftTransfer"
					:cancel-cashbook-closal="cancelCashbookClosal"
					:confirm-cashbook-closal="confirmCashbookClosal"
					:set-cashbook-closal-data="setCashbookClosalData"
					:inventory-act-modal-submit="inventoryActModalSubmit"
					:get-issue-amount="getIssueAmount"
					:act-type="props.actType"
					:issue-amount="props.issueAmount"
					:act-user-from-id="props.actUserFromId"
					:act-user-from-name="props.actUserFromName"
					:act-user-from-position="props.actUserFromPosition"
					:act-user-to-id="props.actUserToId"
					:act-user-to-name="props.actUserToName"
					:act-user-to-position="props.actUserToPosition"
					:act-cash="props.actCash"
					:act-scenario="props.actScenario"
					:act-recorded-amount="props.actRecordedAmount"
					:alert-message="props.alertMessage"
					:lookup-users="lookupUsers"
				/>
				<CashdeskControl
					v-if="!isCashbookClosed"
					:root="root"
					:state_key="state_key"
					:cashbook="root.cashbook"
					:cashdesk="root.cashdesk"
					:toggle-collapsible-component="toggleCollapsibleComponent"
					:collapsed-components="props.collapsedComponents"
					:validation-errors="props.validation_errors"
					:loading-actions="props.loadingActions"
					:open-cashdesk="openCashdesk"
					:close-cashdesk="closeCashdesk"
					:toggle-select-cash-machine-modal="toggleSelectCashMachineModal"
					:lookup-cash-machines="lookupCashMachines"
					:pending-cashbook-orders="root.pending_cashbook_orders"
					:toggle-give-accept-cash-modal="toggleGiveAcceptCashModal"
					:give-accept-cash-modal-defaul-tab="props.giveAcceptCashModalDefaulTab"
					:give-cash-on-cashdesk-closal="props.giveCashOnCashdeskClosal"
					:create-cash-to-cashdesk="createCashToCashdesk"
					:confirm-cash-to-cashdesk="confirmCashToCashdesk"
					:start-cashdesk="startCashdesk"
					:generate-cash-machine-code="generateCashMachineCode"
					:show-cash-machine-otp-input="props.showCashMachineOtpInput"
					:create-cash-from-cashdesk="createCashFromCashdesk"
				/>
				<POSTerminals
					:root="root"
					:state_key="state_key"
					:toggle-collapsible-component="toggleCollapsibleComponent"
					:collapsed-components="props.collapsedComponents"
					:toggle-pos-details-modal="togglePosDetailsModal"
					:get-last-receipt="getLastReceipt"
					:pos-details="props.posDetails"
					:pos-transactions-details="props.posTransactionsDetails"
					:get-pos-transactions="getPosTransactions"
					:refresh-pos-info="refreshPosInfo"
					:loading-actions="props.loadingActions"
					:last-receipt-details="props.lastReceiptDetails"
				/>
				<OpenedCashdesks
					v-if="isChiefCashier"
					:root="root"
					:salepoint="root.salepoint"
					:user="root.user"
					:state="state_key"
					:opened-cashdesks="root.opened_cashdesks"
					:pending-cashbook-orders="root.pending_cashbook_orders"
					:toggle-cashdesk-action-modal="toggleCashdeskActionModal"
					:validation-errors="props.validation_errors"
					:cashdesk-action-modal-data="props.cashdeskActionModalData"
					:toggle-collapsible-component="toggleCollapsibleComponent"
					:collapsed-components="props.collapsedComponents"
					:loading-actions="props.loadingActions"
					:lists="root.lists"
					:toggle-cashdesk-courier-modal="toggleCashdeskCourierModal"
					:toggle-pending-orders-modal="togglePendingOrdersModal"
					:create-cash-from-courier="createCashFromCourier"
					:update-pending-orders="updatePendingOrders"
					:create-cash-to-cashdesk="createCashToCashdesk"
					:confirm-cash-to-cashdesk="confirmCashToCashdesk"
					:cancel-created-order="cancelCreatedOrder"
					:confirm-cash-from-cashdesk="confirmCashFromCashdesk"
					:toggle-closal-shift-modal="toggleClosalShiftModal"
					:confirm-shift-closal="confirmShiftClosal"
					:force-close-cashdesk-shift="forceCloseCashdeskShift"
					:cashdesk-data="props.cashdeskData"
				/>
				<ControlCenterInfo
					:salepoint="root.salepoint"
					:txp-poses-count="root.txp_poses_count"
					:is-chief-cashier="isChiefCashier"
					:show-transfer-button="showTransferButton"
					:open-transfer-modal="toggleTransferWorkplaceModal"
					:loading-actions="props.loadingActions"
				/>
				<TransferWorkplaceModal
					v-if="state_key.render === 'transfer_workplace_modal'"
					:loading-actions="props.loadingActions"
					:root-loading-actions="root.loadingActions"
					:workplace="props.transfer_workplace"
					:salepoint="root.salepoint"
					:find-workplace="findWorkplace"
					:toggle="toggleTransferWorkplaceModal"
					:transfer-user-to-another-salepoint="transferUserToAnotherSalepoint"
				/>
			</template>
			<ControlCenterSplashScreen v-if="state_key === 'idle'" />
		</div>
	</div>
</template>

<script>
import { core, centrifuge } from 'novapay-ui';
import { mapGetters, mapActions } from 'vuex';

import actions from './store/actions';

import CashbookControl from './components/cashbook';
import OpenedCashdesks from './components/opened-cashdesks';
import CashdeskControl from './components/cashdesk';
import ControlCenterInfo from './components/control-center-info.vue';
import ControlCenterSplashScreen from './components/control-center-splash-screen.vue';
import POSTerminals from './components/pos-terminals';
import TransferWorkplaceModal from './components/transfer-workplace-modal';

export default core.createComponent({
	name: 'control_center',
	components: {
		CashbookControl,
		OpenedCashdesks,
		CashdeskControl,
		ControlCenterInfo,
		ControlCenterSplashScreen,
		POSTerminals,
		TransferWorkplaceModal
	},
	actions,
	events: {
		centrifuge,
		listenerAction: 'eventListener'
	},
	beforeMount() {
		this.resetState();
	},
	computed: {
		...mapGetters({
			isChiefCashier: 'root/isChiefCashier',
			isCashbookClosed: 'root/isCashbookClosed'
		}),
		showTransferButton() {
			return !this.isChiefCashier && (!this.root.cashdesk || this.root.cashdesk.status === 'closed');
		}
	},
	methods: {
		...mapActions({
			logout: 'root/logout',
			transferUserToAnotherSalepoint: 'root/transferUserToAnotherSalepoint'
		})
	}
});
</script>

<style lang="scss" scoped>
@import '@assets/scss/mixins';
@import '@assets/scss/variables';

.control-center {
	display: flex;
	justify-content: center;
	margin: 24px;
	.container {
		width: 1132px;
		padding-bottom: 24px;
		box-sizing: border-box;
	}
	@media (max-width: $max-navbar-visibility-width) {
		.container {
			margin: 0 auto;
		}
	}
	@include small-desktop() {
		& .container {
			width: 940px;
		}
		& .salepoint-info {
			flex-direction: column;
			& .col {
				margin-right: 0px;
				flex: 0 0 100%;
				&:first-child {
					margin-right: 0px;
				}
				&:nth-child(2) {
					margin-top: 24px;
				}
			}
		}
	}
	@include mobile() {
		display: block;
		.container {
			width: 100vw;
			margin: 16px 0;
		}
	}
}
</style>
